import { Fade } from 'components/Fade';
import { Row, Col } from 'react-bootstrap';
import { PERSONAS } from 'common/constants';
import 'components/Video/index.scss';

const LINKS = {
  [PERSONAS.TEEN]:
    // eslint-disable-next-line max-len
    'https://play.vidyard.com/kNT3xkVeh9NHKv95BVNauX.html?autoplay=0&custom_id=&embed_button=0&referrer=https%3A%2F%2Fyodaa.club%2F&viral_sharing=0',
  [PERSONAS.PARENT]:
    // eslint-disable-next-line max-len
    'https://cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplay.vidyard.com%2F64t1A1qm2gj7uwxefcDkKf.html%3Fautoplay%3D0%26custom_id%3D%26embed_button%3D0%26viral_sharing%3D0%26&display_name=Vidyard&url=https%3A%2F%2Fshare.vidyard.com%2Fwatch%2F64t1A1qm2gj7uwxefcDkKf%3F&image=https%3A%2F%2Fcdn.vidyard.com%2Fthumbnails%2F10597006%2FDfp2QKe1bMyr969wQGAagsp65xzhTOi-.gif&key=c4e54deccf4d4ec997a64902e9a30300&type=text%2Fhtml&schema=vidyard',
};

export const Video = ({ type }) => (
  <Row className="video justify-content-center">
    <Col className="max-width-container no-pad">
      <Fade>
        <div className="embed-responsive embed-responsive-16by9">
          <iframe
            className="embed-responsive-item"
            src={LINKS[type]}
            scrolling="no"
            title="Vidyard embed"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          />
        </div>
      </Fade>
    </Col>
  </Row>
);
